import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectHideScrollBar } from "../../utils/injectHideScrollBar.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
const selectAnimationDuration = '130ms';
const smallSize = '46px';
const largeSize = '58px';
export const StyledContainer = styled.div.withConfig({ displayName: "auir-41e20d9-StyledContainer", componentId: "auir-41e20d9-1nexqcu" }) `
  --size: ${(props) => (props.size === 'small' ? smallSize : largeSize)};
  --line-height: var(
    ${(props) => props.size === 'small'
    ? props.theme.responsive.typography.copy2.lineHeight
    : props.theme.responsive.typography.copy1.lineHeight}
  );
  --line-size: 2px;
  --gutter-size: calc((var(--size) - var(--line-height)) / 2);

  ${(props) => injectTypography(props, props.size === 'small' ? 'copy2' : 'copy1')}

  ${injectSpacing('margin')}
  display: flex;
`;
export const StyledScrollContainer = styled.div.withConfig({ displayName: "auir-41e20d9-StyledScrollContainer", componentId: "auir-41e20d9-10uoz61" }) `
  position: relative;

  display: grid;

  grid-template-rows: var(--gutter-size) var(--line-height) var(--gutter-size);
  overflow-x: auto;

  ${injectHideScrollBar()}
`;
export const StyledScrollControl = styled.button.withConfig({ displayName: "auir-41e20d9-StyledScrollControl", componentId: "auir-41e20d9-11479an" }) `
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: var(--size);
  max-height: var(--size);
  margin: 0;
  padding: 0;

  color: var(${(props) => props.theme.colors.interaction.secondary.default});

  background: transparent;
  border: 0;
  border-radius: 0;

  transform: ${(props) => props.position === 'start' ? 'rotate(180deg)' : 'none'};
  cursor: pointer;

  appearance: none;

  &:hover {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }

  [dir='rtl'] & {
    transform: ${(props) => props.position === 'end' ? 'rotate(180deg)' : 'none'};
  }

  &:disabled {
    color: var(${(props) => props.theme.colors.interaction.secondary.disabled});

    cursor: not-allowed;
  }
`;
export const StyledScrollIcon = styled.svg.withConfig({ displayName: "auir-41e20d9-StyledScrollIcon", componentId: "auir-41e20d9-gsuqg5" }) `
  width: 24px;
  height: 24px;

  color: currentColor;

  transition: color 0.1s var(${(props) => props.theme.easing});

  pointer-events: none;
`;
export const StyledItem = styled.li.withConfig({ displayName: "auir-41e20d9-StyledItem", componentId: "auir-41e20d9-1sistx3" }) `
  /* stylelint-disable media-feature-name-no-unknown */
  @media (max-width: ${(props) => props.theme.breakpoints.m}px) {
    flex-grow: 1;
  }

  & > * {
    position: relative;

    display: inline-block;
    height: var(--size);
    margin: 0px;
    padding: 0px var(${(props) => props.theme.responsive.spacing.s});

    color: var(${(props) => props.theme.colors.interaction.secondary.default});
    line-height: var(--size);
    white-space: nowrap;
    text-decoration: none;

    background: transparent;
    border: none;
    border-radius: 0;
  }

  & > *::-moz-focus-inner {
    padding: 0;

    border: 0;
  }

  & > *:hover {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }

  & > *[aria-selected='true'],
  & > *[aria-current='true'] {
    color: var(${(props) => props.theme.colors.interaction.secondary.active});
  }

  & > *[aria-disabled] {
    color: var(${(props) => props.theme.colors.interaction.secondary.disabled});

    cursor: not-allowed;
  }

  & > *:focus {
    outline-width: 1px;
    outline-style: solid;
    outline-offset: -1px;
  }

  & > *:focus:not(:focus-visible) {
    outline-width: unset;
    outline-style: unset;
  }
`;
export const StyledList = styled.ul.withConfig({ displayName: "auir-41e20d9-StyledList", componentId: "auir-41e20d9-b5cu4f" }) `
  --indicator-size: 0px;
  --indicator-offset: 0px;
  position: relative;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  grid-row: 1 / 4;

  grid-column: 1;
  justify-content: stretch;
  margin: 0;
  padding: 0;

  list-style: none;
`;
export const StyledBlockIndicator = styled.div.withConfig({ displayName: "auir-41e20d9-StyledBlockIndicator", componentId: "auir-41e20d9-da0uzz" }) `
  position: relative;

  grid-row: 1 / 4;
  grid-column: 1;

  &::after {
    position: absolute;
    left: var(--indicator-offset);

    display: block;
    width: var(--indicator-size);
    height: 100%;

    background-color: var(
      ${(props) => props.theme.colors.ui.highlight.tertiary}
    );
    opacity: 1;

    transition-timing-function: var(${(props) => props.theme.easing});
    transition-duration: ${selectAnimationDuration};

    transition-property: width, left;

    content: '';

    @media (prefers-reduced-motion) {
      transition: none;
    }
  }
`;
export const StyledLineIndicator = styled.div.withConfig({ displayName: "auir-41e20d9-StyledLineIndicator", componentId: "auir-41e20d9-2t2be" }) `
  position: relative;

  grid-row: 3 / 4;
  grid-column: 1;

  &::after {
    position: absolute;
    left: calc(
      var(--indicator-offset) +
        (var(${(props) => props.theme.responsive.spacing.l}) / 2)
    );

    display: block;
    width: calc(
      var(--indicator-size) -
        var(${(props) => props.theme.responsive.spacing.l})
    );
    height: var(--line-size);
    margin-top: var(${(props) => props.theme.responsive.spacing.xxs});

    background-color: var(${(props) => props.theme.colors.ui.primary});
    opacity: 1;

    transition: width ${selectAnimationDuration}
        var(${(props) => props.theme.easing}),
      left ${selectAnimationDuration} var(${(props) => props.theme.easing});

    content: '';

    @media (prefers-reduced-motion) {
      transition: none;
    }
  }
`;
//# sourceMappingURL=GenericNavigation.styles.mjs.mjs.map